const sideBarSection = document.querySelector('.shopify-section.section-page-side-nav');
if (!sideBarSection) return;
const mainEl = document.body.querySelector('main#main');
if (!mainEl) return;

mainEl.classList.add('has-page-sidebar');
